import { callApi } from "@/api/api-core";

export const fetchInfo = function(ownerHandlesFailure) {
    return callApi(
        "POST",
        "v1/products/retireeticket/info",
        {},
        ownerHandlesFailure
    );
};

export const createOrder = function(
    productVariantId,
    validFromInstant,
    amountOfDays,
    ownerHandlesFailure
) {
    const requestData = {
        salesChannelIdentifier: "Webshop",
        productVariantId,
        validFromInstant,
        amountOfDays
    };

    return callApi(
        "POST",
        "v1/products/retireeticket/order",
        requestData,
        ownerHandlesFailure
    );
};
